<template>
  <div
    data-testid="profile-dropdown-organisation"
    class="profile-dropdown__section"
  >
    <div
      data-testid="profile-dropdown-organisation__title"
      class="profile-dropdown__section-title"
    >
      Organisation
    </div>
    <div
      ref="orgList"
      data-testid="profile-dropdown-organisation__list"
      class="profile-dropdown__org-list"
    >
      <div
        v-for="(client, index) in orderedClients"
        :key="String(client._id)"
        :data-testid="`profile-dropdown-organisation__row--${index}`"
        :data-client-id="String(client._id)"
        class="profile-dropdown__org-row"
        :class="{ 'profile-dropdown__org-row--active': isActive(client) }"
        role="button"
        tabindex="0"
        @click.stop="selectClient(client)"
        @keyup.enter.stop="selectClient(client)"
      >
        <span
          v-if="isActive(client)"
          data-testid="profile-dropdown-organisation__check"
          class="profile-dropdown__org-check"
          aria-hidden="true"
        >✓</span>
        <span
          data-testid="profile-dropdown-organisation__name"
          class="profile-dropdown__org-name"
        >{{ client.name }}</span>
      </div>
      <div
        v-if="!clients.length"
        data-testid="profile-dropdown-organisation__empty"
        class="profile-dropdown__empty"
      >
        No organisations
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileDropdownOrganisation',
  props: {
    clients: { type: Array, default: () => [] },
    selectedClientId: { type: String, default: '' }
  },
  emits: ['client-change'],
  computed: {
    activeClientId() {
      return String(
        this.selectedClientId || this.$store?.state?.client || ''
      );
    },
    /** Active org first so it is visible as soon as the menu opens */
    orderedClients() {
      const list = (Array.isArray(this.clients) ? this.clients : [])
        .filter((c) => c && c._id != null);
      const activeId = this.activeClientId;
      if (!activeId) return list;
      return [...list].sort((a, b) => {
        const aActive = String(a._id) === activeId ? 0 : 1;
        const bActive = String(b._id) === activeId ? 0 : 1;
        return aActive - bActive;
      });
    }
  },
  methods: {
    isActive(client) {
      if (!client?._id || !this.activeClientId) return false;
      return String(client._id) === this.activeClientId;
    },
    selectClient(client) {
      if (!client?._id) return;
      const clientId = String(client._id);
      if (clientId === this.activeClientId) return;
      this.$emit('client-change', clientId);
    },
    scrollToSelected() {
      const list = this.$refs.orgList;
      if (!list) return;
      // Active org is sorted to the top — scroll list only (avoid scrollIntoView
      // which can move the page behind the teleported menu).
      list.scrollTop = 0;
    }
  }
};
</script>
